import(/* webpackMode: "eager" */ "/Users/ilias/Github/talnet.co/src/app/auth/signin/layout.js");
